import { FC } from 'react';
import { Modal } from 'antd';

// Shared UI Library Components
import { CustomButton } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './block-counsellor-modal.scss';

type TBlockCounsellorModalProps = {
  open: boolean;
  title: string;
  subtitle?: string;
  onSubmit?: () => void;
  onCancel?: () => void;
}

export const BlockCounsellorModal: FC<TBlockCounsellorModalProps> = (
  {
    open = false,
    title = 'Are you sure you want to block the Counsellor?',
    subtitle = '',
    onSubmit = () => {},
    onCancel = () => {}
  }: TBlockCounsellorModalProps
) => {

  const handleCancel = (): void => {
    onCancel();
  };

  const handleSubmit = (): void => {
    onSubmit();
  }

  return (
    <Modal
      rootClassName="block-counsellor-modal"
      width={ '394px' }
      open={ open }
      centered={ true }
      closeIcon={ null }
      title={ title }
      footer={ [
        <CustomButton key="cancel" text={ 'No' } type={ 'text' } onClick={ handleCancel }/>,
        <CustomButton key="submit" text={ 'Yes' } onClick={ handleSubmit }/>
      ] }
      onCancel={ handleCancel }
    >
      { subtitle }
    </Modal>
  )
};
